const GarlandDecoration = ({ cx, cy, type }) => {
    switch (type) {
        case 'light':
            return (
                <g>
                    <circle cx={cx} cy={cy} r={4} fill="#FCD34D" />
                    <circle cx={cx} cy={cy} r={6} fill="none" stroke="#FCD34D" strokeWidth="1">
                        <animate attributeName="r" values="6;8;6" dur="1.5s" repeatCount="indefinite" />
                        <animate attributeName="opacity" values="0.8;0.4;0.8" dur="1.5s" repeatCount="indefinite" />
                    </circle>
                </g>
            );
        case 'holly':
            return (
                <g>
                    <circle cx={cx} cy={cy} r={3} fill="#DC2626" />
                    <path d={`M${cx-5},${cy-3} Q${cx-2},${cy-8} ${cx+2},${cy-3}`} fill="#166534" />
                    <path d={`M${cx+5},${cy-3} Q${cx+2},${cy-8} ${cx-2},${cy-3}`} fill="#166534" />
                </g>
            );
        default:
            return null;
    }
};

const GarlandDecorationSection = () => {
    return (
        <svg className="w-full h-24">
            {/* Main Garland Paths */}
            <path
            d="M0,40 Q200,80 400,40 Q600,0 800,40"
            fill="none"
            stroke="#2F855A"
            strokeWidth="6"
            />
            <path
            d="M0,40 Q200,80 400,40 Q600,0 800,40"
            fill="none"
            stroke="#166534"
            strokeWidth="12"
            strokeDasharray="4,8"
            strokeOpacity="0.3"
            />
            {/* Decorations */}
            {[...Array(12)].map((_, i) => (
            <GarlandDecoration
                key={i}
                cx={i * 70}
                cy={40 + Math.sin(i * 0.5) * 20}
                type={i % 2 === 0 ? "light" : "holly"}
            />
            ))}
        </svg>
    );
};


export default GarlandDecorationSection;